module.exports = __webpack_public_path__ + "images/msg_card_not_urgent.aa91679f38728f44e558d808232cd923.png";